export const MAX_ACTIVE_WEB_URLS = 3;

export const WEB_URL_TITLE_MAX_LENGTH = 200;
export const WEB_URL_DESCRIPTION_MAX_LENGTH = 1000;
export const WEB_URL_LINK_MAX_LENGTH = 500;
